/**
 * SAIT-22, 06.10.2026: отзывы появляются после основного содержимого страницы.
 * При SPA-переходе модуль отзывов может загрузиться раньше модуля товара.
 */
import { ref, onBeforeUnmount } from 'ui.vue3';

export function usePageContentReady(store, widgetHost) {
    const pageReady = ref(false);
    let pending = null;
    let observer = null;
    let frame = null;
    let settle = null;

    const finish = (ready) => {
        observer?.disconnect();
        observer = null;
        if (frame !== null) {
            cancelAnimationFrame(frame);
            frame = null;
        }
        pageReady.value = ready;
        settle?.(ready);
        settle = null;
    };

    const waitForPageContent = () => {
        if (pending) {
            return pending;
        }
        const blocks = Object.values(store.struct || {});
        const product = blocks.find(block => block.componentData?.VUE_COMPONENT === 'CatalogElement');
        const banner = blocks.find(block => block.componentData?.VUE_COMPONENT === 'MpBanner');
        const productId = Number(product?.componentData?.ITEM?.ID);
        const selector = productId > 0
            ? `.product-detail[data-product-id="${productId}"]`
            : (banner?.componentData?.ITEMS ? '.homescreen' : null);

        pending = new Promise(resolve => {
            settle = resolve;
            // SAIT-146: на главной отзывы в футере, основной контент — в отдельном Vue-корне.
            const root = widgetHost.value?.closest('.vpl-app') || document.querySelector('.vpl-app');
            if (!root) {
                finish(false);
                return;
            }
            const check = () => {
                if (frame !== null || (selector && !root.querySelector(selector))) {
                    return;
                }
                // Дожидаемся завершения текущей отрисовки и mounted основного блока.
                frame = requestAnimationFrame(() => {
                    frame = null;
                    if (!selector || root.querySelector(selector)) {
                        finish(true);
                    }
                });
            };
            observer = new MutationObserver(check);
            observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-product-id'] });
            check();
        });
        return pending;
    };

    onBeforeUnmount(() => finish(false));
    return { pageReady, waitForPageContent };
}
